import { render, staticRenderFns } from "./article-summary.vue?vue&type=template&id=88dbbc14&"
import script from "./article-summary.vue?vue&type=script&lang=js&"
export * from "./article-summary.vue?vue&type=script&lang=js&"
import style0 from "./article-summary.vue?vue&type=style&index=0&id=88dbbc14&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports